import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SeguridadService } from '../servicios/seguridad.service';

@Injectable({
  providedIn: 'root'
})
export class IsLogedGuard implements CanActivate {
  constructor(private seguridadService: SeguridadService, private router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const isValidJwt = this.seguridadService.isValidJwt();
    if (!isValidJwt) {
      this.router.navigate(['/acceso-denegado']);
      return false;
    }
    return true;
  }
}


